import React from 'react'
import { connect } from "react-redux"
import { Link } from 'react-router'
import sortBy from 'lodash/sortBy'

import { getPatientsForParent, fetchPractices, fetchUser, joinPractice } from "../../actions/index"
import { adminSaveUser, adminAddPatient, adminAssignPracticeOwner, adminRemovePracticeOwner } from "../../actions/admin"
import { fetchPracticeUsers, addUserToPractice, moveUserToPracticePending } from "../../actions/practiceAdmin"
import { setTitle } from "../../actions/index"
import CheckBox from '../ui/CheckBox.jsx';

import UserProfileHeader from '../user/UserProfileHeader'
import PatientDetailsForm from './PatientDetailsForm'
import moment from 'moment'



//import styles
//import './styles/UserProfile.scss';

@connect((store) => {
	return {
		users: store.users,
		app: store.app,
		patients: store.patients,
		practices: store.practices
	}
})
class AdminUserProfile extends React.Component {
	constructor(props) {
		super(props);
		this.handleToggleAtt = this.handleToggleAtt.bind(this);
		this.saveUser = this.saveUser.bind(this);
		this.handleInputChange = this.handleInputChange.bind(this);
		this.saveButton = this.saveButton.bind(this)
		this.parentOptions = this.parentOptions.bind(this)
		this.ownerOptions = this.ownerOptions.bind(this)
		this.cardForm = this.cardForm.bind(this)
		this.handleNewPatientInputChange = this.handleNewPatientInputChange.bind(this)
		this.handlePatientInputChange = this.handlePatientInputChange.bind(this)
		this.toggleOpenAddPatient = this.toggleOpenAddPatient.bind(this)
		this.getPatients = this.getPatients.bind(this)
		this.getPractices = this.getPractices.bind(this)
		this.addPatient = this.addPatient.bind(this)
		this.assignPractice = this.assignPractice.bind(this)
		this.state = {
			user: {},
			new_patient: {},
			open_add_patient: false,
			saved: true,
			startDate: moment(),
			therapistCount:''
		}
		this.handleChange = this.handleChange.bind(this)
		this.linkPractice = this.linkPractice.bind(this)
		this.checkPracticeChecked = this.checkPracticeChecked.bind(this)
	}

	componentDidMount() {
		this.getUser();
		this.getPractices()
	}

	toggleOpenAddPatient() {
		this.setState({ open_add_patient: !this.state.open_add_patient })
	}

	handleNewPatientInputChange(e, att) {
		let u = this.state.new_patient;
		u[att] = e.target.value;

		this.setState({
			new_patient: u
		})
	}

	assignPractice(p) {
		if (p.owner === this.state.user._id) {
			// remove
			this.props.dispatch(adminRemovePracticeOwner(p._id, this.state.user._id))
		} else {
			if (p.owner) {
				if (confirm(`There is already an owner for ${p.name}. Re-assign owner?`)) {
					//remove then add
					this.props.dispatch(adminRemovePracticeOwner(p._id, p.owner))
					this.props.dispatch(adminAssignPracticeOwner(p._id, this.state.user._id))
				}
			} else {
				this.props.dispatch(adminAssignPracticeOwner(p._id, this.state.user._id))
			}
		}
	}

	linkPractice(p) {
		let { user } = this.state;
		// console.log(this.state.user);
		if (this.state.user.therapist) {
			if ((this.props.app.practice.therapists !== undefined) &&
				(this.props.app.practice.therapists.indexOf(user._id) > -1)) {
				// remove them
				this.props.dispatch(moveUserToPracticePending('therapists', user._id, p._id))
				user.therapistPractices = user.therapistPractices.filter(function (item) {
					return item._id != p._id;
				});
				this.setState({
					user: user,
					saved: false
				});
			} else {
				// add them
				this.props.dispatch(joinPractice(p._id))
				this.props.dispatch(addUserToPractice('therapists', user._id, p._id))
				user.therapistPractices.push(p);
				this.setState({
					user: user,
					saved: false
				});
			}
		} else if (user.parent) {
			if ((this.props.app.practice.parents !== undefined) &&
				(this.props.app.practice.parents.indexOf(user._id) > -1)) {
				// remove them
				this.props.dispatch(moveUserToPracticePending('parents', user._id, p._id))
				user.practices = user.practices.filter(function (item) {
					return item._id != p._id;
				});
				this.setState({
					user: user,
					saved: false
				});
			} else {
				// add them
				this.props.dispatch(joinPractice(p._id))
				this.props.dispatch(addUserToPractice('parents', user._id, p._id));
				user.practices.push(p);
				this.setState({
					user: user,
					saved: false
				});
			}
		}
		// console.log(this.state);
	}

	getPatients() {
		this.props.dispatch(getPatientsForParent(this.state.user._id))
	}

	getPractices() {
		this.props.dispatch(fetchPractices())
	}

	handlePatientInputChange(e, att, patient) { }

	addPatient(e) {
		e.preventDefault()
		let u = this.state.new_patient;
		u.parent = this.state.user._id;

		this.setState({
			new_patient: u
		})

		this.props.dispatch(adminAddPatient(this.state.new_patient))
		this.toggleOpenAddPatient()
	}

	saveUser() {
		console.log('Save Clicked');
		this.props.dispatch(adminSaveUser(this.state.user))
		this.setState({ saved: true })
	}

	getUser() {
		const { dispatch, params } = this.props
		dispatch(fetchUser(params.id))
			.then(user => {
				this.setState({
					user: user
				});
				dispatch(getPatientsForParent(user._id))
				dispatch(setTitle('User Profile'));
			})
	}

	handleInputChange(e, att) {
		let u = this.state.user;
		u[att] = e.target.value;

		this.setState({
			user: u,
			saved: false
		})
	}

	handleToggleAtt(att) {
		let u = this.state.user;
		u[att] = !u[att];

		this.setState({
			user: u,
			saved: false
		})
		//this.props.dispatch(adminSaveUser(u))
	}

	saveButton() {
		if (!this.state.saved) {
			return <button className="md-button md-raised md-accent right" style={{zIndex:"1000"}}
				onClick={this.saveUser}>Save</button>
		} else {
			return null
		}
	}

	cardForm(heading, content) {
		return <div className="card">
			<div className="card-header" style={{ background: '#efefef' }}>
				<div className="card-content">
					<p>{heading}</p>
				</div>
			</div>
			<div className="card-content">
				{content}
				<div ></div>
			</div>
		</div>
	}

	handleChange(date) {
		this.setState({
			'new_patient': { ...this.state.new_patient, ['dob']: date }
		});
		this.setState({
			startDate: date
		});
	}

	parentOptions() {
		if (this.state.user.parent) {
			let patients = this.props.patients.map(p => <p key={p._id}>{p.firstName} {p.lastName}</p>);
			let content = this.state.open_add_patient ?
				<PatientDetailsForm
					patient={sortBy(this.state.new_patient, ['name'])}
					handleInputChange={this.handleNewPatientInputChange}
					startDate={this.state.startDate}
					handleChange={(date) => {
						this.handleChange(date)
					}}
					handleSubmit={this.addPatient} />
				: patients

			let header = <span>
				<span>Children</span>
				<a onClick={this.toggleOpenAddPatient} className="link right">+</a>
			</span>

			return this.cardForm(header, content)
		} else {
			return null;
		}
	}

	practiceOptions() {
		if (this.state.user.parent || this.state.user.owner || this.state.user.therapist) {
			let content = sortBy(this.props.practices, ['name']).map(p => <p key={p._id}>
				<CheckBox
					onClick={e => this.linkPractice(p)}
					on={this.checkPracticeChecked(p)}
					label={p.name} /></p>);

			let header = <span>Practices</span>
			return this.cardForm(header, content)
		} else {
			return null;
		}
	}

	checkPracticeChecked(practice) {
		let checked = false;
		if (this.state.user.therapist) {
			checked = this.state.user.therapistPractices.find(function (p) {
				return p._id === practice._id;
			});
		} else if (this.state.user.parent) {
			checked = this.state.user.practices.find(function (p) {
				return p._id === practice._id;
			});
		}
		
		return checked;
	}

	ownerOptions() {
		if (this.state.user.owner) {
			let content = sortBy(this.props.practices, ['name']).map(p => <p key={p._id}>
				<CheckBox
					onClick={e => this.assignPractice(p)}
					on={p.owner === this.state.user._id}
					label={p.name} /></p>);

			let header = <span>Owner</span>

			return this.cardForm(header, content)
		} else {
			return null;
		}
	}

	listPractices(practices) {
		return practices ? practices.map((practice, i) => (
			<span key={practice._id}>
				{i ? ', ' : null}
				<Link to={`/practice/${practice.slug}`}>{practice.name}</Link>
			</span>
		)) : null
	}


	render() {
		const { user } = this.state

		return <main className="main user-profile-page">
			<UserProfileHeader user={user} />

			<div className="adminUserProfileDetails">
				<a href="/admin/users" className="backButton">&larr; Back</a>
				{this.saveButton()}
				<p>
					<b>Email:</b> <a href="mailto:{user.email}">{user.email}</a>
				</p>
				<h6>Practices</h6>
				<h6>
					<small>
						Owner ({user.ownPractices ? user.ownPractices.length : '0'})
					</small>
				</h6>
				{this.listPractices(user.ownPractices)}
				<h6>
					<small>
						Therapist ({user.therapistPractices ? user.therapistPractices.length : '0'})
					</small>
				</h6>
				{this.listPractices(user.therapistPractices)}
				<h6>
					<small>
						Patient ({user.practices ? user.practices.length : '0'})
					</small>
				</h6>
				{this.listPractices(user.practices)}
				<br /><br />
				<div className="card">
					<div className="card-content">
						<span onClick={() => { this.handleToggleAtt('parent') }}>
							<CheckBox label="Patient" on={user.parent} ></CheckBox>
						</span>
						<span onClick={() => { this.handleToggleAtt('owner') }}>
							<CheckBox label="Owner" on={user.owner} ></CheckBox>
						</span>
						<span onClick={() => { this.handleToggleAtt('therapist') }}>
							<CheckBox label="Therapist" on={user.therapist} ></CheckBox>
						</span>
					</div>
				</div>
				<div className="grid">
					<div className="card">
						<div className="card-header" style={{ background: '#efefef' }}>
							<div className="card-content">
								<p>Contact details</p>
							</div>
						</div>
						<div className="card-content">
							<form onSubmit={e => false} >
								<label>Phone (Home)</label> <br />
								<input className="md-input md-title"
									autoComplete="off"
									onChange={(e) => this.handleInputChange(e, 'tel_home')}
									value={user.tel_home}
									type="text" placeholder="Phone (Home)." />
								<br /><br />
								<label>Phone (Work)</label> <br />
								<input className="md-input md-title"
									autoComplete="off"
									onChange={(e) => this.handleInputChange(e, 'tel_work')}
									value={user.tel_work}
									type="text" placeholder="Phone (Work)" />
								<br /><br />
								<label>Email</label> <br />
								<input className="md-input md-title"
									autoComplete="off"
									onChange={(e) => this.handleInputChange(e, 'email')}
									value={user.email}
									type="text" placeholder="email" />
							</form>
						</div>
					</div>
					{this.parentOptions()}
					{this.ownerOptions()}
					{this.practiceOptions()}
				</div>
			</div>
		</main>
	}
}


export default AdminUserProfile;



// WEBPACK FOOTER //
// ./src/components/admin/AdminUserProfile.jsx